var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "show" } }, [
    _c("h2", [_vm._v("ファイル詳細")]),
    _vm._v(" "),
    _c("p", [
      _vm._v(
        "他人にこのファイルを共有したい場合、現在のページのURLを共有してください"
      )
    ]),
    _vm._v(" "),
    _c("hr"),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.loading,
            expression: "loading"
          }
        ],
        staticClass: "lds-roller"
      },
      [
        _c("div"),
        _c("div"),
        _c("div"),
        _c("div"),
        _c("div"),
        _c("div"),
        _c("div"),
        _c("div")
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.result,
            expression: "result"
          }
        ]
      },
      [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.success,
                expression: "success"
              }
            ]
          },
          [_c("p", [_vm._v("削除しました")])]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.success,
                expression: "!success"
              }
            ]
          },
          [
            _c("p", { staticClass: "has-text-danger" }, [
              _vm._v(_vm._s(_vm.errMsg))
            ])
          ]
        )
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: !_vm.loading && _vm.main,
            expression: "!loading && main"
          }
        ]
      },
      [
        _c("img", {
          staticStyle: { width: "400px" },
          attrs: {
            src:
              "https://files-uploader.xzy.pw/upload/" +
              this.$route.params.file_name +
              "?show=true",
            alt: "アップロード"
          }
        }),
        _vm._v(" "),
        _c("p", [_vm._v(_vm._s(this.$route.params.file_name))]),
        _vm._v(" "),
        _c("br"),
        _vm._v(" "),
        _c("div", { staticClass: "buttons is-centered" }, [
          _c("section", { staticClass: "copy" }, [
            _vm.isCopied
              ? _c("p", { staticClass: "has-text-info" }, [
                  _vm._v("URLをコピーしました")
                ])
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "button is-primary", on: { click: _vm.exec } },
              [_vm._v("URLをコピー")]
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "button is-danger", on: { click: _vm.deleteFile } },
            [_vm._v("削除する")]
          )
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7c367ea6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7c367ea6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Show.vue
// module id = null
// module chunks = 